import type { AxiosInstance } from "axios";
import { useEffect, useRef } from "react";
import { u2000AxiosAuthenticated } from "./U2000Axios.js";
import { useU2000AuthContext } from "../context/auth/U2000UseAuthContext.js";
import useU2000RefreshToken from "../hooks/authentification/U2000UseRefrehToken.js";
import { useU2000BusyIndicatorContext } from "../context/busiIndicator/U2000BusyIndicatorContext.js";
import { setGlobalCallbacks, setupAxiosInterceptors } from "./U2000AxiosInterceptors.js";

let interceptorsConfigured = false;

const useU2000AxiosAuthenticated = (): AxiosInstance => {
  const { logout } = useU2000AuthContext();
  const doRefreshToken = useU2000RefreshToken();
  const { showBusyIndicator, hideBusyIndicator } = useU2000BusyIndicatorContext();
  const callbacksSetRef = useRef(false);

  useEffect(() => {
    // Configurer les intercepteurs une seule fois au démarrage de l'app
    if (!interceptorsConfigured) {
      if (import.meta.env.DEV) console.debug("[useU2000AxiosAuthenticated] Configuration des intercepteurs");
      setupAxiosInterceptors(u2000AxiosAuthenticated);
      interceptorsConfigured = true;
    }

    // Injecter les callbacks (busy, logout, refreshToken) une seule fois
    if (!callbacksSetRef.current) {
      if (import.meta.env.DEV) console.debug("[useU2000AxiosAuthenticated] Injection des callbacks globaux");
      setGlobalCallbacks(showBusyIndicator, hideBusyIndicator, logout, doRefreshToken);
      callbacksSetRef.current = true;
    }
  }, [showBusyIndicator, hideBusyIndicator, logout, doRefreshToken]);

  return u2000AxiosAuthenticated;
};

export default useU2000AxiosAuthenticated;
